import React from "react";
import logoImg from "@/images/logo_only.png";
import logoLightImg from "@/images/logo-light.png";
import LogoSvgLight from "./LogoSvgLight";
import LogoSvg from "./LogoSvg";
import Link from "next/link";
import { StaticImageData } from "next/image";


export interface LogoProps {
  img?: StaticImageData;
  imgLight?: StaticImageData;
  className?: string;
}

const LogoFooter: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
  className = "",
}) => {
  return (
    <Link
      href="/"
      className={`ttnc-logo inline-block text-primary-600 focus:outline-none focus:ring-0 w-48 ${className}`}
    >
      {/*<LogoSvgLight />
      <LogoSvg />

       THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {img ? (
        <img
          className={`block max-h-48 ${imgLight ? "dark:hidden" : ""}`}
          src={img.src}
          alt="Logo"
          // Explicit dims = no CLS while the bitmap loads; Lighthouse named
          // this <img> specifically as a layout-shift culprit on the home.
          width={img.width}
          height={img.height}
          loading="lazy"
          decoding="async"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className="hidden max-h-12 dark:block"
          src={imgLight.src}
          alt="Logo-Light"
          width={imgLight.width}
          height={imgLight.height}
          loading="lazy"
          decoding="async"
        />
      )}
    </Link>
  );
};

export default LogoFooter;
